"use strict";
// @flow
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.signOperation = void 0;
var rxjs_1 = require("rxjs");
var ledger_signer_1 = require("@taquito/ledger-signer");
var taquito_1 = require("@taquito/taquito");
var deviceAccess_1 = require("../../hw/deviceAccess");
var env_1 = require("../../env");
var errors_1 = require("@ledgerhq/errors");
var modulo_1 = require("../../modulo");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return rxjs_1.Observable.create(function (o) {
            var cancelled;
            function main() {
                var _a, _b, _c;
                return __awaiter(this, void 0, void 0, function () {
                    var fees, freshAddressPath, freshAddress, tezos, ledgerSigner, type, res, opbytes, params, _d, txHash, senders, recipients, accountId, operation;
                    var _this = this;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0:
                                fees = transaction.fees;
                                if (!fees)
                                    throw new errors_1.FeeNotLoaded();
                                freshAddressPath = account.freshAddressPath, freshAddress = account.freshAddress;
                                tezos = new taquito_1.TezosToolkit((0, env_1.getEnv)("API_TEZOS_NODE"));
                                ledgerSigner = new ledger_signer_1.LedgerSigner(transport, freshAddressPath, false, ledger_signer_1.DerivationType.ED25519);
                                tezos.setProvider({ signer: ledgerSigner });
                                // disable the broadcast because we want to do it in a second phase (broadcast hook)
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                tezos.contract.context.injector.inject = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                    return [2 /*return*/, ""];
                                }); }); };
                                o.next({ type: "device-signature-requested" });
                                type = "OUT";
                                params = {
                                    fee: ((_a = transaction.fees) === null || _a === void 0 ? void 0 : _a.toNumber()) || 0,
                                    storageLimit: ((_b = transaction.storageLimit) === null || _b === void 0 ? void 0 : _b.toNumber()) || 0,
                                    gasLimit: ((_c = transaction.gasLimit) === null || _c === void 0 ? void 0 : _c.toNumber()) || 0
                                };
                                if (["delegate", "undelegate"].includes(transaction.mode)) {
                                    // https://ledgerhq.atlassian.net/browse/LL-8821
                                    params.gasLimit = (0, modulo_1.upperModulo)(transaction.gasLimit || new bignumber_js_1["default"](0), new bignumber_js_1["default"](136), new bignumber_js_1["default"](1000)).toNumber();
                                }
                                _d = transaction.mode;
                                switch (_d) {
                                    case "send": return [3 /*break*/, 1];
                                    case "delegate": return [3 /*break*/, 3];
                                    case "undelegate": return [3 /*break*/, 5];
                                }
                                return [3 /*break*/, 7];
                            case 1: return [4 /*yield*/, tezos.contract.transfer(__assign({ mutez: true, to: transaction.recipient, amount: transaction.amount.toNumber() }, params))];
                            case 2:
                                res = _e.sent();
                                opbytes = res.raw.opbytes;
                                return [3 /*break*/, 8];
                            case 3: return [4 /*yield*/, tezos.contract.setDelegate(__assign(__assign({}, params), { source: freshAddress, delegate: transaction.recipient }))];
                            case 4:
                                res = _e.sent();
                                opbytes = res.raw.opbytes;
                                type = "DELEGATE";
                                return [3 /*break*/, 8];
                            case 5: return [4 /*yield*/, tezos.contract.setDelegate(__assign(__assign({}, params), { source: freshAddress }))];
                            case 6:
                                res = _e.sent();
                                opbytes = res.raw.opbytes;
                                type = "UNDELEGATE";
                                return [3 /*break*/, 8];
                            case 7: throw new Error("not supported");
                            case 8:
                                if (cancelled) {
                                    return [2 /*return*/];
                                }
                                o.next({ type: "device-signature-granted" });
                                txHash = "";
                                senders = [freshAddress];
                                recipients = [transaction.recipient];
                                accountId = account.id;
                                operation = {
                                    id: "".concat(accountId, "-").concat(txHash, "-").concat(type),
                                    hash: txHash,
                                    type: type,
                                    value: transaction.amount,
                                    fee: fees,
                                    extra: {
                                        storageLimit: transaction.storageLimit,
                                        gasLimit: transaction.gasLimit
                                    },
                                    blockHash: null,
                                    blockHeight: null,
                                    senders: senders,
                                    recipients: recipients,
                                    accountId: accountId,
                                    date: new Date()
                                };
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        signature: opbytes,
                                        expirationDate: null
                                    }
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
            return function () {
                cancelled = true;
            };
        });
    });
};
exports.signOperation = signOperation;
//# sourceMappingURL=signOperation.js.map